import { styled } from "styled-components";

//Apply color gradient, pink and orange
export const Name = styled.span`
  // background: linear-gradient( #FF00D6, #FF4D00);
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
  // background-clip: text;
  // text-fill-color: transparent;

  text-shadow: -2.1px -2.1px 0.5px ${({theme}) => theme.textShadowColor};
  font-weight: 900;
  font-size: 2rem;
`;